import {appointmentApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const updateAppointment = async (model) => {
  try {
    const result = await fetch(`${appointmentApiHostName}`, {
      method: "PUT",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(model),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
